module.exports = __webpack_public_path__ + "img/Wien.8183460e.jpg";